import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

// WP-plugin deploy injects `gild-backoffice-root` into the WP page; the
// standalone SST subdomain deploy uses CRA's `public/index.html` which has
// `root`. Try the WP id first so embedded behavior is unchanged, then fall
// back to `root` for standalone + local dev.
const wpRoot = document.getElementById('gild-backoffice-root')
const target = wpRoot || document.getElementById('root');

// On the standalone subdomain deploy, migrate legacy HashRouter URLs
// (`/backoffice/#/quotes/abc`) into BrowserRouter paths (`/quotes/abc`) so
// old bookmarks continue to deep-link correctly. Guarded on the absence of
// the WP-injected div — in the WP-plugin context HashRouter is the correct
// behavior and must not be rewritten.
if (!wpRoot && window.location.hash.startsWith('#/')) {
  const path = window.location.hash.slice(1)
  window.history.replaceState(null, '', path)
}

if (target) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    target
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
